import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IInterviewer, IInterviewerCreate, IInterviewerUpdate } from '@tsin-core/states/interviewer/interviewer.models';
import { UserRoleEnum } from '@tsin-shared/enums/UserRoleEnum';
import { environment } from '@tsin-env/environment';
import { map, Observable } from 'rxjs';

const INTERVIEWER_URL = `${environment.externalApiUrl}/user`;
const PRO_INTERVIEWER_LIST_URL = `${environment.apiUrl2}/user`;
const WWUS_POOL_URL = `${environment.apiUrl}/supervisors/wwus-pool`;

@Injectable({
  providedIn: 'root'
})
export class InterviewerService {

  private http = inject(HttpClient);


  // POST: Create a new interviewer
  createInterviewer(interviewer: IInterviewerCreate): Observable<IInterviewer> {
    return this.http.post<IInterviewer>(INTERVIEWER_URL, interviewer);
  }

  // PUT: Update an existing interviewer
  updateInterviewer(interviewer: IInterviewerUpdate): Observable<IInterviewer> {
    return this.http.put<IInterviewer>(`${INTERVIEWER_URL}`, interviewer);
  }

  // GET: Fetch all interviewers via PRO-Backend (proxied from WWUS)
  getInterviewers(): Observable<IInterviewer[]> {
    return this.http
      .get<{ data: IInterviewer[]; count: number }>(
        `${WWUS_POOL_URL}?role=${UserRoleEnum.PRO_INTERVIEW}`,
      )
      .pipe(
        map((response) =>
          (response.data || []).map((interviewer) => ({
            ...interviewer,
            role: UserRoleEnum.PRO_INTERVIEW,
          })),
        ),
      );
  }

  // POST: Upload file or additional data related to interviewer
  uploadInterviewerData(data: any, id: string): Observable<any> {
    return this.http.post(`${INTERVIEWER_URL}/upload`, data);
  }

  // GET: Fetch a single interviewer by ID
  getInterviewer(id: string): Observable<IInterviewer> {
    return this.http.get<IInterviewer>(`${INTERVIEWER_URL}/single/${id}`);
  }

  // DELETE: Delete an interviewer by ID
  deleteInterviewer(id: string): Observable<any> {
    return this.http.delete(`${INTERVIEWER_URL}/single/${id}`);
  }

}
